import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const App = () => {
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (token) {
      try {
        const decoded = jwtDecode(token); // Token dekodieren
        if (decoded.workspace_id === 143287) { // 143287 ist die ID des Workspaces https://app.autopilotz.de/
          window.location.href = "https://frontend.eventwonders.de/auth/login?token=" + token;
        } else if (decoded.workspace_id === 100833) { // Production
          window.location.href = "https://frontend100833.autopilotz.de/auth/login?token=" + token;
        } else if (decoded.workspace_id === 200137) { // Production
          window.location.href = "https://frontend200137.autopilotz.de/auth/login?token=" + token;
        } else if (decoded.workspace_id === 199213) { // Production
          window.location.href = "https://frontend199213.autopilotz.de/auth/login?token=" + token;
        } else {
          setErrorMessage("Zugriff verweigert: Dieser Service ist für Sie nicht verfügbar.");
        }
      } catch (error) {
        console.error("Ungültiges Token", error);
        setErrorMessage("Fehler: Das Token ist ungültig oder beschädigt.");
      }
    } else {
      setErrorMessage("Fehler: Kein Token gefunden.");
    }
  }, [location]);

  return <div className="error-container">
    <h1>{errorMessage}</h1>
  </div>;
};

export default App;